import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import React, { Fragment } from 'react';
import { TCustomerPlanType } from 'FeatureModules/Auth/types/company.types';

interface IProps {
  allowedPlans: TCustomerPlanType[];
  children: React.ReactNode;
}

const HasAccess: React.FC<IProps> = ({ allowedPlans, children }) => {
  const { plan } = useCompanyPlanContext();

  if (allowedPlans.includes(plan)) {
    return <Fragment>{children}</Fragment>;
  }

  return null;
};

export default HasAccess;
